import './style.css'

document.querySelector<HTMLDivElement>('#app')!.innerHTML = `
<header class="hero">
  <div class="hero-inner">
    <p class="eyebrow">Family History Fair</p>
    <h1><span class="stars">★</span> &ldquo;Americana 250&rdquo; <span class="stars">★</span></h1>
    <p class="tagline">Discover, Preserve, and Celebrate Your Family History</p>

    <dl class="meta">
      <div>
        <dt>Date</dt>
        <dd>Saturday, 19 September 2026</dd>
      </div>
      <div>
        <dt>Time</dt>
        <dd>9:00 AM – 3:00 PM</dd>
      </div>
      <div>
        <dt>Location</dt>
        <dd>34 Chestnut Ferry Road<br />Camden, SC</dd>
      </div>
    </dl>

    <a class="cta" href="#register">Register Today &rarr;</a>
    <p class="cta-note">Attendance is free &middot; Space is limited</p>
  </div>
</header>

<main>
  <section class="intro">
    <p>
      Are you ready to unlock your family&rsquo;s past? Whether you are a beginner or looking to
      enhance your existing family history research, the &ldquo;Americana 250&rdquo; Fair is your
      ultimate gateway to discovery. Experience expert education, interactive exhibits, and
      cutting-edge digital preservation tools designed to bring your lineage to life.
    </p>
  </section>

  <section class="section">
    <h2><span class="section-icon" aria-hidden="true">📚</span> Knowledge &amp; Learning Sessions</h2>
    <ul class="feature-list">
      <li>
        <strong>Keynote:</strong>
        Enhance your family history research using rarely used, little-known Americana records.
      </li>
      <li>
        <strong>Expert Classes:</strong>
        Gain deep, professional insights from certified family history instructors.
      </li>
      <li>
        <strong>Self-Teaching Webcasts:</strong>
        Learn at your own pace with curated, taped instructional video sessions.
      </li>
    </ul>
  </section>

  <section class="section">
    <h2><span class="section-icon" aria-hidden="true">💾</span> Digital Archiving &amp; Memory Preservation</h2>
    <p class="section-lede">
      Interactive technology stations will demonstrate how to digitize and save your family legacy:
    </p>
    <ul class="feature-list">
      <li>
        <strong>Free FamilySearch Account:</strong>
        Register on-site to add your data and unlock billions of ancestral records.
      </li>
      <li>
        <strong>7-Generation Fan Chart:</strong>
        Use your account to generate and receive a stunning visual map of your lineage.
      </li>
      <li>
        <strong>Fast Photo Scanning:</strong>
        Bulk-scan boxes of print photographs in just a fraction of the time.
      </li>
      <li>
        <strong>VHS Digitization:</strong>
        Convert old family home videos into modern digital video formats.
      </li>
      <li>
        <strong>Slides &amp; Negatives Transfer:</strong>
        Scan physical film pieces and transfer them directly to a flash drive.
      </li>
      <li>
        <strong>Flatbed Scanner:</strong>
        Safely digitize historical documents, certificates, and maps.
      </li>
    </ul>
  </section>

  <section class="section">
    <h2><span class="section-icon" aria-hidden="true">🎉</span> Interactive Fun &amp; Community</h2>
    <ul class="feature-list">
      <li>
        <strong>Free-Standing Exhibits:</strong>
        Engage with hands-on, interactive activities to expand your data-recording insights.
      </li>
      <li>
        <strong>Old-Fashioned Family BBQ:</strong>
        Take a break and network with fellow enthusiasts over a delicious complimentary lunch.
      </li>
    </ul>
  </section>

  <section id="register" class="register">
    <div class="register-card">
      <p class="eyebrow">Register Today</p>
      <h2>Save Your Spot</h2>
      <p class="register-lede">
        Attendance is free; however, space is limited. Secure your spot and claim your
        complimentary BBQ lunch ticket by registering below.
      </p>

      <form
        id="signup-form"
        class="signup-form"
        action="https://formspree.io/f/mwlekwlp"
        method="POST"
      >
        <div class="field">
          <label for="firstName">First Name</label>
          <input id="firstName" name="firstName" type="text" autocomplete="given-name" required />
        </div>

        <div class="field">
          <label for="lastName">Last Name</label>
          <input id="lastName" name="lastName" type="text" autocomplete="family-name" required />
        </div>

        <div class="field">
          <label for="email">Email</label>
          <input id="email" name="email" type="email" autocomplete="email" required />
        </div>

        <div class="field">
          <label for="phone">Phone <span class="optional">(optional)</span></label>
          <input id="phone" name="phone" type="tel" autocomplete="tel" />
        </div>

        <div class="field">
          <label for="attendees">Number Attending</label>
          <input id="attendees" name="attendees" type="number" min="1" max="20" value="1" required />
        </div>

        <div class="field">
          <label for="bbq">BBQ Lunch Tickets</label>
          <input id="bbq" name="bbq" type="number" min="0" max="20" value="1" required />
        </div>

        <div class="field field--full">
          <label for="interests">What are you most interested in? <span class="optional">(optional)</span></label>
          <textarea id="interests" name="interests" rows="3" placeholder="Photo scanning, classes, keynote…"></textarea>
        </div>

        <div class="field field--full checkbox-field">
          <label>
            <input type="checkbox" id="firstTime" name="firstTime" />
            <span>This is my first family history event</span>
          </label>
        </div>

        <button type="submit" class="submit-btn">Register &rarr;</button>

        <p class="form-status" id="form-status" role="status" aria-live="polite"></p>
      </form>
    </div>
  </section>
</main>

<footer class="site-footer">
  <p>
    Sponsored by the Church of Jesus Christ of Latter-day Saints,<br />
    Hartsville South Carolina Stake, Camden FamilySearch Center
  </p>
</footer>
`
